<template>
  <v-card dark class="elevation-10">
    <v-card-text>
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="paymentDetail"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td @click="viewInvoice(item)" class="text-left">
              {{ item.Invoice.localId }}
            </td>

            <td class="text-left">
              {{ item.Invoice.Customer.name }}
            </td>

            <td @click="viewInvoice(item)" class="text-left">
              {{ item.amount | currency }}
            </td>

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="viewInvoice(item)">
                    <v-list-item-title>View invoice</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(32)"
                    @click="deletePayment(item)"
                  >
                    <v-list-item-title>Delete Payment</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import paymentService from "../service";
// import DateTimePicker from "../../../../components/DateTimePicker";
import { mapGetters } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();
export default {
  props: {
    CustomerId: {
      default: null,
    },
    PaymentId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    due: {
      default: false,
    },
  },
  name: "payment-detail-list",
  data() {
    return {
      count: 0,
      loading: true,
      headers: [
        {
          text: "Invoice Number",
          align: "left",
          value: "localId",
          sortable: true,
        },
        {
          text: "Customer Name",
          align: "left",
          value: "Invoice.Customer.name",
          sortable: true,
        },
        {
          text: "Amount",
          align: "left",
          value: "amount",
          sortable: true,
        },

        {
          text: "",
          value: "action",
          sortable: false,
          width: "20px",
        },
      ],
      paymentDetail: [],
      search: null,
      page: 1,
      sortBy: "Invoice.localId",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  created() {
    this.getList();
  },
  methods: {
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.InvoiceId);

      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getList() {
      // // console.log('payment', this.PaymentId)
      return paymentService
        .getDetailById(this.PaymentId, { CustomerId: this.CustomerId })
        .then((response) => {
          // console.log('vresponse', response)
          this.paymentDetail = response.data;
          this.loading = false;
          return response;
        });
    },
    deletePayment(payment) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          paymentService.deletePaymentDetail(payment.id).then((response) => {
            if (response.data) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Payee has been deleted.",
                });
              // this.$swal("Deleted!", "Payee has been deleted.", "success");
              this.getList();
              this.$events.emit("paymentListEvent");
              this.$events.emit("customerProfileEvent");
              this.$events.emit("invoiceListEvent");
            }
          });
        }
      });
    },
  },
};
</script>
